/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { useLayout } from '../../core'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { AsideMenu } from './AsideMenu'
import { RootState } from 'src/setup'
import { shallowEqual, useSelector } from 'react-redux'

const AsideDefault: FC = () => {
  const logo = useSelector(
    ({ auth }: RootState) =>
      auth?.user?.partners?.logo?.startsWith('http') ? auth?.user?.partners?.logo : undefined,
    shallowEqual
  )
  const { config, classes } = useLayout()
  const { aside } = config

  return (
    <div
      id='kt_aside'
      className={clsx('aside', classes.aside.join(' '))}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_mobile_toggle'
    >
      {/* begin::Brand */}
      <div className='aside-logo flex-column-auto align-items-start' id='kt_aside_logo'>
        {/* begin::Logo */}
        {aside.theme === 'dark' && (
          <Link to='/dashboard' className='mt-13 fs-2 text-white flex-fill d-flex justify-content-center'>
            <img
              alt='Logo'
              className='pt-2 logo img-fluid w-160px'
              src={toAbsoluteUrl('/media/icons/padma/LogoPadma.png')}
            />
            <img alt='Logo' src={toAbsoluteUrl('/favicon.ico')} className='h-40px logo-small' />
          </Link>
        )}
        {aside.theme === 'light' && (
          <Link to='/dashboard' className='mt-13'>
            <img
              alt='Logo'
              className='pt-2 logo img-fluid'
              style={{ height: 60 }}
              src={logo ?? toAbsoluteUrl('/media/icons/padma/LogoPadma.png')}
            />
          </Link>
        )}
        {/* end::Logo */}

        {/* begin::Aside toggler */}
        {aside.minimize && (
          <div
            id='kt_aside_toggle'
            className='btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle'
            data-kt-toggle='true'
            data-kt-toggle-state='active'
            data-kt-toggle-target='body'
            data-kt-toggle-name='aside-minimize'
          >
            <KTSVG
              path={'/media/icons/duotune/arrows/arr080.svg'}
              className={'svg-icon-1 rotate-180'}
            />
          </div>
        )}
        {/* end::Aside toggler */}
      </div>
      {/* end::Brand */}

      {/* begin::Aside menu */}
      <div className='aside-menu flex-column-fluid'>
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
      </div>
      {/* end::Aside menu */}
    </div>
  )
}

export { AsideDefault }
